import { render, staticRenderFns } from "./TermoSensorVirtual.vue?vue&type=template&id=e63c6706&scoped=true&"
import script from "./TermoSensorVirtual.vue?vue&type=script&lang=js&"
export * from "./TermoSensorVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63c6706",
  null
  
)

export default component.exports